export default {
  addCard: {
    title: "افزودن کارت بانکی جدید",
    warning: "دقت کنید، کارتی که ثبت می کنید باید به اسم خودتان باشد.",
    inputLabel: "شماره کارت",
    button: "بررسی و افزودن کارت",
    verifyButton: "تایید شد",
    invalidCardNumber: "شماره کارت وارد شده معتبر نیست."
  },
  notRegisteredCard: {
    title: "تایید نشد",
    button: "درخواست مجدد ثبت کارت"
  },
  notRegisteredShebaCard: {
    title: "تایید نشد",
    button: "درخواست مجدد ثبت شبا"
  },
  offlinePaymentNoticeCard: {
    title:
      "دقت کنید؛ شناسه واریز، همان کد ملی شما است. حتما هنگام واریز آفلاین، شناسه واریز را روی فیش بانکی خود بنویسید.",
    hideCheckbox: "این پیام دیگر نمایش داده نشود",
    button: "متوجه شدم"
  },
  userRegisteredCard: {
    title: "شما هیچ کارت بانکی ثبت نکرده‌اید",
    description:
      "برای واریز ریالی ابتدا کارت بانکی خود را ثبت کنید. دقت کنید برای واریز ریالی فقط از کارت‌های بانکی ثبت شده استفاده نمایید. در غیر اینصورت تراکنش شما به حالت تعلیق در می‌آید.",
    button: "افزودن کارت بانکی"
  },
  notAvailableCard: {
    title: "شما هیچ کارت بانکی ثبت نکرده‌اید",
    description:
      "برای واریز ریالی ابتدا کارت بانکی خود را ثبت کنید. دقت کنید برای واریز ریالی فقط از کارت‌های بانکی ثبت شده استفاده نمایید. در غیر اینصورت تراکنش شما به حالت تعلیق در می‌آید.",
    button: "افزودن کارت بانکی"
  },
  depositConfirmationCard: {
    desPartOne: "دقت کنید برای واریز ریالی ",
    desPartTwo: "فقط از کارت‌های بانکی ثبت شده ",
    desPartThree:
      "استفاده نمایید در غیر اینصورت تراکنش شما به حالت تعلیق در می‌آید.",
    continueButton: "متوجه شدم، برو به درگاه",
    registeredCard: "کارت‌های ثبت شده شما",
    addCard: "افزودن کارت جدید"
  },
  accountList: {
    title: "شماره حساب و کارت‌های اکسکوینو"
  },
  suggestionApps: {
    goToPWA: "رفتن به نسخه وب اپلیکیشن",
    installGuide:
      "برای افزودن وب اپلیکیشن اکسکوینو به صفحه اصلی موبایل خود مراحل زیر را طی کنید:",
    shareTitle: "در نوار پایین روی دکمه {n} بزنید",
    addToHomeTitle: "در منوی باز‌شده، در قسمت پایین، گزینه {n} انتخاب کنید.",
    addTitle: "در مرحله بعد در قسمت بالا روی {n} بزنید",
    confirmButton: "متوجه شدم"
  },
  expiredOrderCard: {
    title: "پایان زمان تکمیل سفارش",
    subtitle: "مدت زمان شما برای تکمیل این سفارش به اتمام رسید",
    repeatOrderButton: "انجام مجدد همین سفارش",
    goToWalletButton: "بازگشت به صفحه کیف پول"
  },
  cancelOrderCard: {
    title: "لغو سفارش",
    subtitle: "آیا مطمئن هستید می‌خواهید سفارش خود را لغو کنید؟",
    cancelOrderButton: "مطمئنم، لغو کن",
    goBackButton: "انصراف از لغو"
  }
};
